import { YouLostModalActionType } from '../../types/youLostModalType'

export const closeYouLostModal = () => {
    return {type: YouLostModalActionType.CLOSE_YOU_LOST_MODAL}
}

export const openYouLostModal = () => {
    return {type: YouLostModalActionType.OPEN_YOU_LOST_MODAL}
}